<template>
  <div class="sanitasToolTip">
    <dotcom-tooltip :content="content" :is-text-link="false" />
    <p class="sanitasToolTip-title">{{ label }}</p>
  </div>
</template>

<script>
import DotcomTooltip from '@/modules/tooltip/Tooltip'

export default {
  name: 'SanitasTooltip',

  components: {
    DotcomTooltip,
  },

  props: {
    content: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="postcss">
.sanitasToolTip {
  &-title {
    font-weight: 400;
    font-size: 13px;
    line-height: 1.35;
    color: var(--c-primary-neutral-1);
    display: inline-block;
    margin-top: 0;
  }

  & >>> .dotcom-icon {
    font-size: 18px;
  }

  &:hover {
    .sanitasToolTip {
      &-title {
        color: var(--c-tint-color-1);
      }
    }
  }
}
</style>
